import React, { useEffect } from "react";
import { useState } from "react";
import placesService from "../../services/places";
import universitiesService from "../../services/universities";
import degreesService from "../../services/degrees";

const Datos = ({ register, errors, product }) => {
  const [universities, setUniversities] = useState([]);
  const [places, setPlaces] = useState([]);
  const [degrees, setDegrees] = useState([]);

  const fetchUniversities = async () =>
    await universitiesService
      .get()
      .then((res) => setUniversities(res))
      .catch((err) => console.error(err));

  const fetchPlaces = async () =>
    await placesService.get().then((res) => setPlaces(res));

  const fetchDegrees = async () =>
    await degreesService
      .get()
      .then((res) => setDegrees(res))
      .catch((err) => console.error(err));
  useEffect(() => {
    fetchUniversities();
    fetchPlaces();
    fetchDegrees();
  }, []);

  return (
    <div className="grid grid-cols-2 gap-2">
      <div className="w-full">
        <input
          type="date"
          className={`${
            errors.age ? "bg-red-200 placeholder:text-red-600" : " bg-custom-azul-claro placeholder:text-custom-azul-medio"
          } text-custom-azul-oscuro text-sm p-2 px-6 rounded-xl outline-none focus:outline-custom-azul-oscuro focus:bg-white outline-offset-0 outline-1 w-full`}
          placeholder="Tu edad"
          {...register("age", {
            required: "*Espacio obligatorio",
            min: { value: 18, message: "Debes minimo 18 años." },
            max: { value: 30, message: "Debes tener maximo 30 años." },
          })}
          //onChange={(e) => setName(e.target.value)}
        />
        {errors.age && (
          <i className="text-xs ml-3 text-red-600">{errors.age.message}</i>
        )}
      </div>
      <div className="w-full">
        <input
          type="number"
          className={`${
            errors.phone ? "bg-red-200 placeholder:text-red-600" : "bg-custom-azul-claro placeholder:text-custom-azul-medio"
          } text-custom-azul-oscuro text-sm p-2 px-6 rounded-xl outline-none focus:outline-custom-azul-oscuro focus:bg-white outline-offset-0 outline-1 w-full`}
          placeholder="Tu celular"
          {...register("phone", {
            required: "*Espacio obligatorio",
            maxLength: { value: 10, message: "Maximo 10 numeros" },
            minLength: { value: 10, message: "Minimo 10 numeros" },
          })}
        />
        {errors.phone && (
          <i className="text-xs ml-3 text-red-600">{errors.phone.message}</i>
        )}
      </div>
      <div className="col-span-2">
        <select
          className={`${
            errors.university ? "bg-red-200 text-red-600" : "bg-custom-azul-claro text-custom-azul-oscuro"
          } text-sm p-2 px-6 rounded-xl outline-none focus:outline-custom-azul-oscuro focus:bg-white outline-offset-0 outline-1 w-full`}
          placeholder="¿Cuál es tu universidad o ciudad?"
          {...register("university", { required: "*Espacio obligatorio" })}
        >
          <option value="">¿Cuál es tu universidad o ciudad?</option>
          {universities?.map((uni) => (
            <option key={uni} value={uni}>
              {uni}
            </option>
          ))}
        </select>
      
        {errors.university && (
          <i className="text-xs ml-3 text-red-600">
            {errors.university.message}
          </i>
        )}
      </div>
      <div className="col-span-2">
      {(product === "GTa" || product === "GTe") && (<select
          className={`${
            errors.career ? "bg-red-200 text-red-600" : "bg-custom-azul-claro text-custom-azul-oscuro"
          } text-sm p-2 px-6 rounded-xl outline-none focus:outline-custom-azul-oscuro focus:bg-white outline-offset-0 outline-1  w-full`}
          placeholder="¿Qué estudias? (o estudiaste)"
          {...register("career", { required: "*Espacio obligatorio" })}
        >
          <option value="">¿Qué estudias? (o estudiaste)</option>
          {degrees?.map((degree) => (
            <option key={degree} value={degree}>
              {degree}
            </option>
          ))}
        </select>)
        }
        {errors.career && (
          <i className="text-xs ml-3 text-red-600">{errors.career.message}</i>
        )}
      </div>
      <div className="col-span-2">
        <select
          className={`${
            errors.referal ? "bg-red-200 text-red-600" : "bg-custom-azul-claro text-custom-azul-oscuro"
          } text-sm p-2 px-6 rounded-xl outline-none focus:outline-custom-azul-oscuro focus:bg-white outline-offset-0 outline-1 w-full`}
          placeholder="¿Cómo te enteraste de nosotros?"
          {...register("referal", { required: "*Espacio obligatorio" })}
        >
          <option value="">¿Cómo te enteraste de nosotros?</option>
          {places?.map((place) => (
            <option key={place} value={place}>
              {place}
            </option>
          ))}
        </select>
        {errors.referal && (
          <i className="text-xs ml-3 text-red-600">
            {errors.referal.message}
          </i>
        )}
      </div>
      <p className="mt-4 text-xs text-gray-400 pl-3 col-span-2">
        Tus datos están seguros. Al registrarte, confirmas que aceptas la
        Política de Privacidad.
      </p>
    </div>
  );
};

export default Datos;
